export default function getLocalization(stringKey) {
  if (typeof window.siipiweikot2026_screenReaderText === 'undefined' || typeof window.siipiweikot2026_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.siipiweikot2026_screenReaderText[stringKey];
}
